<div class="bg-gray-100 shadow border-b border-gray-400 text-gray-500  text-center py-4">{{title}}</div>